import { render, staticRenderFns } from "./notification.global.vue?vue&type=template&id=c95a1b5a&"
import script from "./notification.global.vue?vue&type=script&lang=js&"
export * from "./notification.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports